module.exports = __webpack_public_path__ + "img/Path -10.69af3611.svg";